import { render, staticRenderFns } from "./FrameworkControlsTable.vue?vue&type=template&id=64357361&"
import script from "./FrameworkControlsTable.vue?vue&type=script&lang=js&"
export * from "./FrameworkControlsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports